export enum ExcludeCharacterFilterTypes {
  Default = 0,
  NoSpaces,
  Amount,
  Date,
  Numbers
}

export const getExcludeCharacterFilter = (excludeCharacterFilter: ExcludeCharacterFilterTypes) => {
  if (excludeCharacterFilter === ExcludeCharacterFilterTypes.NoSpaces) {
    return /\s/g;
  }

  if (excludeCharacterFilter === ExcludeCharacterFilterTypes.Amount) {
    return /[^\d-.,]/g;
  }

  if (excludeCharacterFilter === ExcludeCharacterFilterTypes.Numbers) {
    return /[^\d]/g;
  }

  if (excludeCharacterFilter === ExcludeCharacterFilterTypes.Date) {
    return /[^\d-]/g;
  }
  // eslint-disable-next-line no-empty-character-class
  return /[]/g;
};

export const filterCharacters = (value: string, excludeCharacterFilter: ExcludeCharacterFilterTypes) => {
  if (excludeCharacterFilter === ExcludeCharacterFilterTypes.Default) {
    return value;
  }
  const filter = getExcludeCharacterFilter(excludeCharacterFilter);
  return value.replace(filter, "");
};
